export const constMenu = [
	{
		name: "Features",
		namemenu: "NavBarDesktop.NavBarDesktopFeatures",
		link: "/Features",
		icon: "/Menu/feature.png"
	},
	{
		name: "Services",
		namemenu: "NavBarDesktop.NavBarDesktopServices",
		link: "/Services",
		icon: "/Menu/service.png"
	},
	{
		name: "Document",
		namemenu: "Menu.Document",
		link: "/Document/How-to-Create-a-Project-in-MMA/1",
		icon: "/Menu/document.png"
	}
	// {
	// 	name: "Projects",
	// 	namemenu: "NavBarDesktop.NavBarDesktopProjects",
	// 	sub: [
	// 		{
	// 			name: "GlobalProjects",
	// 			namemenu: "NavBarDesktop.NavBarDesktopGlobalProjects",
	// 			link: "/GlobalProjects",
	// 			icon: "/Menu/project.png"
	// 		},
	// 		{
	// 			name: "MyProjects",
	// 			namemenu: "NavBarDesktop.NavBarDesktopMyProjects",
	// 			link: "/MyProjects",
	// 			icon: "/Menu/project.png"
	// 		}
	// 	],
	// 	link: "/GlobalProjects",
	// 	icon: "/Menu/project.png"
	// },
	// {
	// 	name: "Community",
	// 	namemenu: "NavBarDesktop.NavBarDesktopCommunity",
	// 	link: "/Community",
	// 	icon: "/Menu/community.png"
	// },
	// {
	// 	name: "Blogs",
	// 	namemenu: "Blogs.Blogs",
	// 	link: "/Blogs",
	// 	icon: "/Menu/blog.png"
	// },
	// {
	// 	name: "Tutorial",
	// 	namemenu: "NavBarDesktop.NavBarDesktopHelp",
	// 	link: "/Tutorial",
	// 	icon: "/Menu/tutorial.png"
	// }
]
